"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const StoreContext_1 = require("../StoreContext");
const withStore = (mapStoreToProps) => (Component) => {
    const computeProps = (store, props) => {
        if (mapStoreToProps) {
            return Object.assign(Object.assign({}, mapStoreToProps(store)), props);
        }
        return props;
    };
    const WithStoreComponent = props => (react_1.default.createElement(StoreContext_1.StoreConsumer, null, ({ store, updateStore }) => react_1.default.createElement(Component, Object.assign({}, computeProps(store, props), { updateStore: updateStore }))));
    return WithStoreComponent;
};
exports.default = withStore;
